import { DefaultListFilter } from './../base-components/default-list-filter/default-list-filter.component';
import { FilterContainerDirective } from './../base-components/default-list/filter-container.directive';
import { UserService } from './../base-services/user.service';
import { BaseContainerService } from './containers/services/base-container-service';
import { RefreshType } from './../base-models/refresh-type';
import { QueryParameter } from './../base-models/query-parameter';
import { BaseEntity } from './../base-models/base-entity';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './base-component';
import { BaseDataService } from './../base-services/base-data.service';
import { Subscription, BehaviorSubject, Observable, of } from 'rxjs';
import { OnInit, OnDestroy, ViewChild, Optional, Inject, Output, EventEmitter, Input, inject, ChangeDetectorRef } from '@angular/core';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { List, set } from 'immutable';
import { ModalService } from '../base-services/modal.service';
import { RequestType } from '../base-models/request-type';
import { ModelData } from '../base-models/model-data';
import { ModelDataService } from '../base-services/model-data.service';
import { DefaultTableComponent } from '../base-components/default-table/default-table.component';
import { PrintType } from '../base-models/print-type';
import { BaseDefaultListFilterComponent } from '../base-components/default-list-filter/base-default-list-filter-component';
// import { ConfirmationDialogButtons } from '../../public_api';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { ListData } from '../base-models/list-data';
import { NotificationService } from '../base-services/notification-service';
import { finalize } from 'rxjs/operators';
// import { ToastrService } from 'ngx-toastr';

interface ItemWithPodVrstaDokumentaStavkaID {
    Checked: boolean;
    PodVrstaDokumentaStavkaID: number;
}

export class BaseListComponent<T extends BaseEntity> extends BaseComponent implements OnInit, OnDestroy {
    // constructor(
    //     protected activatedRoute: ActivatedRoute,
    //     protected baseDataService: BaseDataService,
    //     protected containerService: BaseContainerService<T>,
    //     protected userService: UserService,
    //     protected notificationsService: NotificationsService,
    //     protected translateService: TranslateService,
    //     protected modalService: ModalService,
    //     @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService,
    // ){
    //     super(activatedRoute, userService, modelDataService);
    // }

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected containerService: BaseContainerService<T>,
        protected userService: UserService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService,
    ) {
        super(activatedRoute, userService, modelDataService);
    }

    @Output() TableMainItemSelect = new EventEmitter<T>();

    private _detailItemsSubscription: Subscription;
    private _detail1ItemsSubscription: Subscription;
    private _mainItemsSubscription: Subscription;
    private _emittedItemSubscription: Subscription;

    private _detailLoadToken: number = 0;

    private _lastDetailLoadID: number = null;
    private _lastDetailLoadTime: number = 0;

    //private mainItemsSubject = new BehaviorSubject<T[]>([]);
    //mainItemsObservable = this.mainItemsSubject.asObservable();
    mainItems: List<T>;
    detailItems: List<any>;
    detail1Items: List<any>;
    itemsUpdated: boolean = false;

    MainItemsLoading: boolean = false;
    DetailItemsLoading: boolean = false;
    Detail1ItemsLoading: boolean = false;

    @ViewChild(FilterContainerDirective, { static: true }) filterContainer: FilterContainerDirective;
    @ViewChild(DefaultTableComponent, { static: false }) defaultTable: DefaultTableComponent;
    filterComponent: BaseDefaultListFilterComponent;

    @Output() MainItemSelected: EventEmitter<T> = new EventEmitter<T>();
    @Output() totalRecordsChanged = new EventEmitter<number>();
    _model: string;
    private _modelData: ModelData;
    protected _parentPropertyName: string;
    protected _parentPropertyValue: number;

    // @Input() set Model(value: string){
    //         this._model = value;
    //         if (this._model  && this.modelDataService){
    //             this.modelData = this.modelDataService.GetModelDataByPath(this._model);
    //         }
    //     }
    @Input() infiniteScroll: boolean = false;

    @Input() CustomDeleteConfirmation: (item: T) => Promise<boolean>;
    @Input() set ModelData(value: ModelData) {
        this._modelData = value;
    }

    @Input() set ParentPropertyName(value: string) {
        this._parentPropertyName = value;
    }

    @Input() set ParentPropertyValue(value: number) {
        this._parentPropertyValue = value;
        if (value && value > 0) {
            this.LoadMainItems()
        }
        else {
            this.mainItems = List([]);
            this.detailItems = List([]);
            this.detail1Items = List([]);
        }
    }

    private getQueryParameter(): QueryParameter[] {
        let queryParameters: QueryParameter[] = [];
        let queryParameter = new QueryParameter();
        queryParameter.Name = this._parentPropertyName;
        queryParameter.Value = this._parentPropertyValue;
        queryParameters.push(queryParameter);
        return queryParameters;
    }

    parentID: number = null;

    private logTabFlowDebug(methodName: string, data: any) {
        const w = typeof window !== 'undefined' ? (window as any) : null;
        if (!w || w.__TAB_FLOW_DEBUG !== true) {
            return;
        }
        console.log('[TAB-FLOW-DEBUG]', methodName, data);
    }

    private buildTabFlowSnapshot(item: any = null, idParameter: number = null) {
        const hasMainItems = !!this.mainItems;
        const selectedItem = hasMainItems ? this.mainItems.find(mainItem => mainItem && mainItem.Selected) : null;
        const detailList = this.modelData && this.modelData.MainList ? this.modelData.MainList.DetailList : null;
        return {
            timestamp: Date.now(),
            currentTab: null,
            itemID: item && item.ID != null ? item.ID : null,
            idParameter: idParameter,
            mainItemsExists: hasMainItems,
            mainItemsCount: hasMainItems ? this.mainItems.size : 0,
            selectedItemExists: !!selectedItem,
            selectedItemID: selectedItem && selectedItem.ID != null ? selectedItem.ID : null,
            refreshType: this.modelData ? this.modelData.RefreshType : null,
            detailListExists: !!detailList,
            detailListCount: detailList ? detailList.length : 0
        };
    }

    ngOnInit() {
        super.ngOnInit();

        this._emittedItemSubscription = this.containerService.EmittedItem
            .subscribe((item: T | null) => {

                if (this.modelData.MainList.SelectName) {
                    this.selectNameMetod(item).subscribe((arr: T[] | null) => {
                        this.processEmittedItem(arr && arr.length ? arr[0] : null);
                    });
                } else {
                    this.processEmittedItem(item ? item : null);
                }
            });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this._mainItemsSubscription != null)
            this._mainItemsSubscription.unsubscribe();

        if (this._detailItemsSubscription != null)
            this._detailItemsSubscription.unsubscribe();
        if (this._detail1ItemsSubscription != null)
            this._detail1ItemsSubscription.unsubscribe();

        if (this._emittedItemSubscription != null)
            this._emittedItemSubscription.unsubscribe();

        this.mainItems = List();
        this.detailItems = List();
        this.detail1Items = List();
    }

    OnModelDataLoaded() {
        if (this._modelData)
            this.modelData = this._modelData;
        if (this.modelData.LoadOnInit && this.modelData.MainList.DefaultListFilterComponent == null) {
            this.LoadMainItems();
            //this.loadItems(this.modelData.MainList.ModelName, this.modelData.MainList.GetName, this.modelData.MainList.GetParameters, this.modelData.MainList.ModelClass)
            //.subscribe((data: T[]) => {
            //this.mainItems = data;
            //this.OnMainItemsLoaded();
            //})
        }
    }
    currentPage: number = 1;
    pageSize: number = 15;
    totalRecords: number = 0;
    sort: string = ''
    orderBy: string = 'DESC'

    LoadMainItems(refresh: boolean = false, filterParameters = null) {
        this.logTabFlowDebug('LoadMainItems', this.buildTabFlowSnapshot(null, null));

        if (this.modelData.MainList.Pagination) {
            filterParameters = {
                ...filterParameters,
                PageNumber: this.currentPage,
                PageSize: this.pageSize,
                SortBy: this.sort || '',
                OrderBy: this.orderBy || 'DESC'
            };
        }

        if (this._modelData)
            this.modelData = this._modelData;

        let getQueryParameter: QueryParameter[];
        if (this._parentPropertyName)
            getQueryParameter = this.getQueryParameter();
        else
            getQueryParameter = this.modelData.MainList.GetParameters;

        if (!this.mainItems || this.modelData.RefreshType == RefreshType.Reload || refresh) {

            if (this._mainItemsSubscription) {
                this._mainItemsSubscription.unsubscribe();
                this._mainItemsSubscription = null;
            }

            this.MainItemsLoading = true;

            this._mainItemsSubscription = this.loadItems<T>(
                this.modelData.MainList.ModelName,
                this.modelData.MainList.GetName,
                getQueryParameter,
                this.modelData.MainList.ShortModelClass,
                this.modelData.MainList.RequestType,
                getQueryParameter.length > 0 ? getQueryParameter[0] : null,
                filterParameters
            )
                .pipe(finalize(() => {
                    this.MainItemsLoading = false;
                }))
                .subscribe(
                    (data: T[]) => {
                        if (this.currentPage === 1 || !this.mainItems || !this.infiniteScroll) {
                            this.mainItems = List(data);
                        } else {
                            this.mainItems = this.mainItems.concat(List(data));
                        }

                        this.detailItems = List([]);
                        this.detail1Items = List([]);
                        this.OnMainItemsLoaded();

                        if (this.modelData.MainList.Pagination) {
                            this.getTotalRecords(filterParameters);
                        }
                    },
                    (err) => {
                    }
                );
        }
    }


    LoadMainItemsWithID(filterParameters = null, ID: number): Observable<T[]> {
        this.logTabFlowDebug('LoadMainItemsWithID', this.buildTabFlowSnapshot(null, ID));

        if (this.modelData.MainList.Pagination) {
            filterParameters = {
                ...filterParameters,
                PageNumber: this.currentPage,
                PageSize: this.pageSize,
                SortBy: this.sort || '',
                OrderBy: this.orderBy || 'DESC'
            };

        }

        filterParameters = {
            ...filterParameters,
            ID: ID
        };

        if (this._modelData)
            this.modelData = this._modelData;

        let getQueryParameter: QueryParameter[];
        if (this._parentPropertyName)
            //m//        if (this._parentPropertyName && this._parentPropertyValue)
            getQueryParameter = this.getQueryParameter();
        else
            getQueryParameter = this.modelData.MainList.GetParameters;

        //let parameters: QueryParameter[] = [];
        //this.modelData.MainList.GetParameters.forEach(queryParameter => {
        //parameters.push(queryParameter);
        //})
        //Object.keys(filterParameters).forEach(property => {
        //parameters.push(new QueryParameter(property, filterParameters[property]))
        //})

        return this.loadItems<T>(
            this.modelData.MainList.ModelName,
            this.modelData.MainList.GetName,
            getQueryParameter,
            //parameters,
            this.modelData.MainList.ShortModelClass, this.modelData.MainList.RequestType,
            // this.modelData.MainList.GetParameters.length > 0 ? this.modelData.MainList.GetParameters[0] : null, filterParameters)
            getQueryParameter.length > 0 ? getQueryParameter[0] : null, filterParameters)
    }


    LoadDetailItems<P extends BaseEntity>(ID: number) {
        this.logTabFlowDebug('LoadDetailItems', this.buildTabFlowSnapshot(null, ID));

        // if (this.parentID === ID && this.detailItems && this.detailItems.size > 0) {
        //     const w = typeof window !== 'undefined' ? (window as any) : null;
        //     if (w && w.__TAB_FLOW_DEBUG === true) {
        //         console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.skipSameID', {
        //             timestamp: Date.now(),
        //             parentID: ID,
        //             detailItemsCount: this.detailItems.size,
        //             detail1ItemsCount: this.detail1Items ? this.detail1Items.size : null
        //         });
        //     }
        //     return;
        // }

        const now = Date.now();

        if (this._lastDetailLoadID === ID && (now - this._lastDetailLoadTime) < 300) {
            return;
        }

        this._lastDetailLoadID = ID;
        this._lastDetailLoadTime = now;

        const detailLoadToken = ++this._detailLoadToken;

        this.parentID = ID;

        if (this._detailItemsSubscription != null)
            this._detailItemsSubscription.unsubscribe();

        if (this._detail1ItemsSubscription != null)
            this._detail1ItemsSubscription.unsubscribe();

        if (this._modelData)
            this.modelData = this._modelData;

        const w = typeof window !== 'undefined' ? (window as any) : null;

        if (this.modelData.MainList.DetailList.length > 0) {
            let parameter = new QueryParameter();
            parameter.Name = this.modelData.MainList.DetailList[0].ParentProperty;
            parameter.Value = ID;

            this.DetailItemsLoading = true;

            if (w && w.__TAB_FLOW_DEBUG === true) {
                console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.before', {
                    timestamp: Date.now(),
                    detailListIndex: 0,
                    parentID: ID,
                    modelName: this.modelData.MainList.DetailList[0].ModelName,
                    getName: this.modelData.MainList.DetailList[0].GetName,
                    listRole: this.modelData.MainList.DetailList[0].ParentProperty,
                    detailLoadToken: detailLoadToken
                });
            }

            this._detailItemsSubscription = this.loadItems<P>(
                this.modelData.MainList.DetailList[0].ModelName,
                this.modelData.MainList.DetailList[0].GetName,
                [parameter],
                this.modelData.MainList.DetailList[0].ShortModelClass,
                this.modelData.MainList.DetailList[0].RequestType,
                null
            ).subscribe((data) => {
                if (w && w.__TAB_FLOW_DEBUG === true) {
                    console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.next', {
                        timestamp: Date.now(),
                        detailListIndex: 0,
                        parentID: ID,
                        modelName: this.modelData.MainList.DetailList[0].ModelName,
                        getName: this.modelData.MainList.DetailList[0].GetName,
                        listRole: this.modelData.MainList.DetailList[0].ParentProperty,
                        resultCount: data && data.length != null ? data.length : null,
                        detailLoadToken: detailLoadToken,
                        currentDetailLoadToken: this._detailLoadToken
                    });
                }

                if (detailLoadToken !== this._detailLoadToken) {
                    if (w && w.__TAB_FLOW_DEBUG === true) {
                        console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.skipped', {
                            timestamp: Date.now(),
                            detailListIndex: 0,
                            parentID: ID,
                            resultCount: data && data.length != null ? data.length : null,
                            detailLoadToken,
                            currentDetailLoadToken: this._detailLoadToken
                        });
                    }
                    return;
                }

                this.detailItems = List(data);

                if (w && w.__TAB_FLOW_DEBUG === true) {
                    console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.applied', {
                        timestamp: Date.now(),
                        detailListIndex: 0,
                        parentID: ID,
                        resultCount: data && data.length != null ? data.length : null,
                        assignedCount: this.detailItems ? this.detailItems.size : null,
                        detailLoadToken,
                        currentDetailLoadToken: this._detailLoadToken
                    });
                }

                this.OnDetailItemsLoaded();
            });
        }

        if (this.modelData.MainList.DetailList.length > 1) {
            let parameter = new QueryParameter();
            parameter.Name = this.modelData.MainList.DetailList[1].ParentProperty;
            parameter.Value = ID;

            this.Detail1ItemsLoading = true;

            if (w && w.__TAB_FLOW_DEBUG === true) {
                console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.before', {
                    timestamp: Date.now(),
                    detailListIndex: 1,
                    parentID: ID,
                    modelName: this.modelData.MainList.DetailList[1].ModelName,
                    getName: this.modelData.MainList.DetailList[1].GetName,
                    listRole: this.modelData.MainList.DetailList[1].ParentProperty,
                    detailLoadToken: detailLoadToken
                });
            }

            this._detail1ItemsSubscription = this.loadItems<P>(
                this.modelData.MainList.DetailList[1].ModelName,
                this.modelData.MainList.DetailList[1].GetName,
                [parameter],
                this.modelData.MainList.DetailList[1].ShortModelClass,
                this.modelData.MainList.DetailList[1].RequestType,
                null
            ).subscribe((data) => {
                if (w && w.__TAB_FLOW_DEBUG === true) {
                    console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.next', {
                        timestamp: Date.now(),
                        detailListIndex: 1,
                        parentID: ID,
                        modelName: this.modelData.MainList.DetailList[1].ModelName,
                        getName: this.modelData.MainList.DetailList[1].GetName,
                        listRole: this.modelData.MainList.DetailList[1].ParentProperty,
                        resultCount: data && data.length != null ? data.length : null,
                        detailLoadToken: detailLoadToken,
                        currentDetailLoadToken: this._detailLoadToken
                    });
                }

                if (detailLoadToken !== this._detailLoadToken) {
                    if (w && w.__TAB_FLOW_DEBUG === true) {
                        console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.skipped', {
                            timestamp: Date.now(),
                            detailListIndex: 1,
                            parentID: ID,
                            resultCount: data && data.length != null ? data.length : null,
                            detailLoadToken,
                            currentDetailLoadToken: this._detailLoadToken
                        });
                    }
                    return;
                }

                this.detail1Items = List(data);

                if (w && w.__TAB_FLOW_DEBUG === true) {
                    console.log('[TAB-FLOW-DEBUG-DETAIL]', 'LoadDetailItems.applied', {
                        timestamp: Date.now(),
                        detailListIndex: 1,
                        parentID: ID,
                        resultCount: data && data.length != null ? data.length : null,
                        assignedCount: this.detail1Items ? this.detail1Items.size : null,
                        detailLoadToken,
                        currentDetailLoadToken: this._detailLoadToken
                    });
                }

                this.OnDetail1ItemsLoaded();
            });
        }
    }


    RefreshMainItem(ID: number) {
        this.baseDataService.Get(
            this.modelData.MainList.ModelName,
            'GetViewItemByID',
            [new QueryParameter('id', ID)],
            this.modelData.MainList.ShortModelClass
        ).subscribe((updatedItem: any) => {
            const index = this.getItemIndex(ID, this.mainItems);
            if (index >= 0) {
                this.mainItems = this.updateItem(updatedItem, this.mainItems, index);
            }
        });
    }



    searchKeyword: string = '';
    OnMainItemsLoaded() {
        this.MainItemsLoading = false;
    }

    OnDetailItemsLoaded() {
        this.DetailItemsLoading = false;
    }

    OnDetail1ItemsLoaded() {
        this.Detail1ItemsLoading = false;
    }

    OnItemInserted(item: T) {
        if (this._modelData)
            this.modelData = this._modelData;

        if (this.modelData.RefreshType == RefreshType.NoReload) {
            this.mainItems = this.addItem(item, this.mainItems)
        }
        else {
            this.LoadMainItems();
        }
    }

    OnItemUpdated(item: T) {
        if (this._modelData)
            this.modelData = this._modelData;

        if (this.modelData.RefreshType == RefreshType.NoReload) {
            // this.mainItems[this.getItemIndex(item.ID, this.mainItems)] = item;
            const index = this.getItemIndex(item.ID, this.mainItems);
            this.mainItems = this.updateItem(item, this.mainItems, index);
        }
        else {
            this.LoadMainItems();
        }
    }

    OnItemDeleted(ID: number) {
        if (this._modelData)
            this.modelData = this._modelData;

        if (this.modelData.RefreshType == RefreshType.NoReload) {
            this.mainItems = this.mainItems.splice(this.getItemIndex(ID, this.mainItems), 1)
            //this.mainItemsSubject.next(Object.assign([], this.mainItems));
        }
        else {
            this.LoadMainItems(true, this.filterComponent ? this.filterComponent.filterFormGroup.value : null);
        }
    }
    OnDetail1ItemDeleted(ID: number) {
        if (this.modelData.RefreshType == RefreshType.NoReload) {
            this.detail1Items = this.detail1Items.splice(this.getItemIndex(ID, this.detail1Items), 1);
        }

        if (this.modelData.MainList.DetailList[1].RefreshMainlistItem && this.parentID) {
            this.RefreshMainItem(this.parentID);
        }
    }
    DeleteItemByID(ID: number) {
        //this.DeleteItem(this.mainItems.find(item => item.ID == ID));
        this.DeleteItem(this.getItemByID(ID, this.mainItems, null));
    }

    private getItemByID(ID: number, items: List<T>, selectedItem): T {
        //let selectedItem;
        items.forEach((item: T) => {
            if (item.ID == ID)
                selectedItem = item;
            else if (item["Items"])
                selectedItem = this.getItemByID(ID, item["Items"], selectedItem);
            else
                return null;
        })
        return selectedItem;
    }

    DeleteItem(item: T) {
        if (this._modelData)
            this.modelData = this._modelData;
        this.translateService.get([this.modelData.MainTitle + '.AKUZATIV', 'FW.ACTION.DELETE.ACTIONNAME', 'FW.ACTION.DELETE.MESSAGE.SUCCESS', 'FW.ACTION.DELETE.QUESTION', 'FW.ACTION.DELETE.MESSAGE.LOCK'])
            .subscribe(translate => {
                //provera da li je zaključano, ako je zaključano da ne može pitalica za brisanje
                this.baseDataService.GetByID(this.modelData.MainList.ModelName, item.ID, this.modelData.MainList.ModelClass)
                    .subscribe(data => {
                        if (data && data["Useridlk"] && data["Useridlk"] != null) {
                            // this.notificationsService.warn(translate['FW.ACTION.DELETE.ACTIONNAME'],translate['FW.ACTION.DELETE.MESSAGE.LOCK'])
                            this.toastrService.warning(translate['FW.ACTION.DELETE.ACTIONNAME'], translate['FW.ACTION.DELETE.MESSAGE.LOCK'])
                        }
                        else {
                            //if(confirm('Da li ste sigurni da želite da obrišete ' + translate[this.modelData.MainTitle + '.AKUZATIV'] + '?')){
                            //if(confirm(translate['FW.ACTION.DELETE.QUESTION'] + this.getPropertyValue(item[this.modelData.MainList.DefaultPropertyName]) + '?')){
                            const confirmationPromise = this.CustomDeleteConfirmation
                                ? this.CustomDeleteConfirmation(item)
                                : this.showDeleteConfirmationDialog(item);

                            confirmationPromise.then(result => {
                                if (result) {
                                    this.baseDataService.Delete(this.modelData.MainList.ModelName, item.ID)
                                        .subscribe(data => {
                                            this.OnItemDeleted(data);
                                            //this.notificationsService.success(translate['FW.ACTION.DELETE.ACTION'], 'Uspešno obrisano');
                                            // this.notificationsService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], this.getPropertyValue(item[this.modelData.MainList.DefaultPropertyName]));
                                            this.toastrService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], this.getPropertyValue(item[this.modelData.MainList.DefaultPropertyName]).toString());
                                            if (this.mainItems.size > 0) this.SelectMainItem(this.mainItems[0])
                                            else {
                                                this.detailItems = List([]);
                                                this.detail1Items = List([]);
                                            }
                                        })
                                }
                            }, (reason) => {

                            })
                            //}
                        }
                    })
            })
    }
    showDeleteConfirmationDialog(item: T): Promise<boolean> {
        if (this._modelData)
            this.modelData = this._modelData;

        return this.translateService.get([
            this.modelData.MainTitle + '.AKUZATIV',
            'FW.ACTION.DELETE.ACTIONNAME',
            'FW.ACTION.DELETE.QUESTION'
        ]).toPromise().then(translations => {
            const title = translations['FW.ACTION.DELETE.ACTIONNAME'];
            const message = `${translations['FW.ACTION.DELETE.QUESTION']}${this.getPropertyValue(item[this.modelData.MainList.DefaultPropertyName])}?`;

            return this.modalService.ShowConfirmationDialog(title, message, 'question').result;
        }).then(result => {
            return result === true;
        }).catch(() => {

            return false;
        });
    }
    DeleteItems() {
        this.mainItems.forEach(item => {
            if (item.Checked)
                this.DeleteItem(item);
        })
    }

    CheckItem(ID: number, isChecked: boolean) {
        //this.mainItems[this.getItemIndex(ID, this.mainItems)].Checked = isChecked;
        let tempItem = this.mainItems.find(mainItem => mainItem.ID == ID)
        tempItem.Checked = isChecked;
    }

    SelectMainItem(item: T) {
        this.logTabFlowDebug('SelectMainItem', this.buildTabFlowSnapshot(item, item && item.ID != null ? item.ID : null));
        //this.mainItems.forEach(item => item.Selected = false);
        this.mainItems.filter(mainItem => mainItem.Selected == true).forEach(item1 => item1.Selected = false);
        if (item != null) {
            //item.Selected = true;
            //let tempItem = this.mainItems[this.getItemIndex(item.ID, this.mainItems)];
            let tempItem = this.mainItems.find(mainItem => mainItem.ID == item.ID);
            tempItem.Selected = true;
            //this.mainItems.update(this.getItemIndex(item.ID, this.mainItems), mainItem => mainItem = tempItem);
            this.LoadDetailItems(item.ID);
            this.defaultTable.ScrollToView = true;
        }
        else {
            this.detailItems = List([]);
            this.detail1Items = List([]);
        }
        this.MainItemSelected.emit(item);
    }

    SelectDetailItem(item: T) {
        // this.mainItems.filter(mainItem => mainItem.Selected == true).forEach(item1 => item1.Selected = false);
        if (item != null) {
            let tempItem = this.detail1Items.find(detail1Item => detail1Item.ID == item.ID);
            tempItem.Selected = true;
            //    .defaultTable.ScrollToView = true;
        }
        // else{
        //     this.detailItems = null;
        //     this.detail1Items = null;
        // }
        //this.MainItemSelected.emit(item);
    }

    SelectMainItemByID(ID: number) {
        this.SelectMainItem(this.getItemByID(ID, this.mainItems, null));
    }

    CustomPrint() {
        this.Print();
    }

    Print(parameters?: any) {
        //console.log('print');
        if (this._modelData)
            this.modelData = this._modelData;
        let itemsChecked = this.mainItems.filter(item => item.Checked == true);
        const tipListe = this.modelData.MainList.PrintType
            && (this.modelData.MainList.PrintType == PrintType.List || this.modelData.MainList.PrintType == PrintType.FilteredList);
        const filtriranaLista = this.modelData.MainList.PrintType && this.modelData.MainList.PrintType == PrintType.FilteredList;

        if ((itemsChecked != null && itemsChecked.size > 0) || tipListe) {
            var _PodVrstaDokumentaStavkaID: number = 0;

            this.mainItems.forEach((item: any) => {
                const typedItem = item as ItemWithPodVrstaDokumentaStavkaID;
                if (typedItem.Checked) {
                    _PodVrstaDokumentaStavkaID = typedItem.PodVrstaDokumentaStavkaID;
                }
            });

            this.translateService.get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel))
                .subscribe(translate => {
                    this.modalService.ShowPrintDialog(
                        translate
                        , this.modelData.MainList.EnablePrintAccountSelection
                        , this.modelData.MainList.PrintController
                        && this.modelData.MainList.PrintController == 'Report'
                        && this.modelData.MainList.PrintType
                        && this.modelData.MainList.PrintType == PrintType.Document
                        && itemsChecked.count() > 1
                        , _PodVrstaDokumentaStavkaID
                        // Print bi trebao da prima parametre koji bi bili defaultna vrednost za kontrole na WIPS-u
                        // , "Memorandum"
                    )
                        .result
                        .then((value) => {
                            if (value.AllInOneDoc || tipListe)
                                this.printAllInOneDoc(value, parameters);
                            else {
                                let id: number;
                                this.mainItems.forEach(item => {
                                    if (item.Checked) {
                                        id = item.ID;
                                        this.print(id, value, parameters);
                                    }
                                })
                            }
                        }, () => { })
                })
        }
        else
            this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Odaberite dokument.",
                "alert",
                ConfirmationDialogButtons.Ok
            );

        //this.translateService.get(this.modelData.BreadcrumbLabel)
        //.subscribe(translate => {
        //this.modalService.ShowPrintDialog(translate)
        //.result
        //.then((value) => {
        //this.baseDataService.GetFile(this.modelData.MainList.ModelName, this.modelData.MainList.PrintName, { ReportPars: [{ Name: 'ID', Value: id }], WipsPars: { parReportTitle: value.Title, parReportSubtitle: value.Subtitle, parPageNoYes: value.ShowPageCount, parPageNoPosition: value.PageNoPosition, parTimeZoneInfo: 'Central Europe Standard Time', parHeaderType: value.ReportHeaderTypes, parPageFooterType: value.ReportPageTypes}})
        //.subscribe(file => {
        //let fileUrl = URL.createObjectURL(file);
        //window.open(fileUrl);
        //})
        //}, () => {})
        //})
    }

    PrintItem(ID: number) {
        if (this._modelData)
            this.modelData = this._modelData;
        this.translateService.get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel))
            .subscribe(translate => {
                this.modalService.ShowPrintDialog(translate
                    , this.modelData.MainList.EnablePrintAccountSelection, false)
                    .result
                    .then((value) => {
                        //alert(ID);
                        this.print(ID, value);
                    }, () => { })
            })
    }

    printAllInOneDoc(value, parameters?: any) {
        if (this._modelData)
            this.modelData = this._modelData;
        let checkedIDs: string = '';
        let numberOfcheckedIDs: number = 0;
        this.mainItems.forEach(item => {
            if (item.Checked) {
                checkedIDs += item.ID + ',';
                numberOfcheckedIDs += 1;
            }
        })
        checkedIDs = checkedIDs.substring(0, checkedIDs.length - 1);

        let controllerName: string;
        let controllerMethodName: string;
        if (this.modelData.MainList.PrintController) {
            controllerName = this.modelData.MainList.PrintController;
            controllerMethodName = 'Printaj';
        }
        else {
            controllerName = this.modelData.MainList.ModelName;
            controllerMethodName = this.modelData.MainList.PrintName;
        }

        let reportPars = [
            { Name: 'IDs', Value: checkedIDs }
            , { Name: 'PrintMethod', Value: this.modelData.MainList.PrintName }
            , { Name: 'PrintType', Value: this.modelData.MainList.PrintType }
            , { Name: 'FilterDescription', Value: this.filterComponent ? this.filterComponent.FilterDescription : "" }
            , { Name: 'NumberOfRecords', Value: this.mainItems.size }
            , { Name: 'NumberOfCheckedRecords', Value: numberOfcheckedIDs }
        ]

        if (this.filterComponent.filterFormGroup.value) {
            const rawFilter = this.filterComponent.filterFormGroup.value;

            const filterParams = Object.keys(rawFilter).map(key => ({
                Name: key,
                Value: JSON.stringify(rawFilter[key])

            }));

            reportPars.push({
                Name: 'FilterParameters',
                Value: JSON.stringify(filterParams)
            });
        }

        if (parameters) {
            Object.keys(parameters).forEach(key => {
                reportPars.push({ Name: key, Value: parameters[key] });
            });
        }

        this.baseDataService.GetFile(controllerName, controllerMethodName, {
            ReportPars: reportPars,
            WipsPars: {
                parReportTitle: value.Title,
                parReportSubtitle: value.Subtitle,
                parPageNoYes: value.ShowPageCount,
                parPageNoPosition: value.PageNoPosition,
                parTimeZoneInfo: 'Central Europe Standard Time',
                parHeaderType: value.ReportHeaderTypes,
                parPageFooterType: value.ReportPageTypes,
                parCompanyAccounts: value.FirmaZrcs
                , parIzvestajId: value.TipDokumenta
                , parOdloziIUEregistrator: value.Eregistrator
            }
        }).subscribe(file => {
            let fileUrl = URL.createObjectURL(file);
            window.open(fileUrl);
        })
    }

    private print(ID: number, value, parameters?: any) {
        if (this._modelData)
            this.modelData = this._modelData;
        let controllerName: string;
        let controllerMethodName: string;
        if (this.modelData.MainList.PrintController) {
            controllerName = this.modelData.MainList.PrintController;
            controllerMethodName = 'Printaj';
        }
        else {
            controllerName = this.modelData.MainList.ModelName;
            controllerMethodName = this.modelData.MainList.PrintName;
        }

        let reportPars = [{ Name: 'ID', Value: ID },
        { Name: 'PrintMethod', Value: this.modelData.MainList.PrintName }];

        if (parameters) {
            Object.keys(parameters).forEach(key => {
                reportPars.push({ Name: key, Value: parameters[key] });
            });
        }

        //this.baseDataService.GetFile(this.modelData.MainList.ModelName, this.modelData.MainList.PrintName, {
        this.baseDataService.GetFile(controllerName, controllerMethodName, {
            ReportPars: reportPars
            , WipsPars: {
                parReportTitle: value.Title
                , parReportSubtitle: value.Subtitle
                , parPageNoYes: value.ShowPageCount
                , parPageNoPosition: value.PageNoPosition
                , parTimeZoneInfo: 'Central Europe Standard Time'
                , parHeaderType: value.ReportHeaderTypes
                , parPageFooterType: value.ReportPageTypes
                , parCompanyAccounts: value.FirmaZrcs
                , parIzvestajId: value.TipDokumenta
                , parOdloziIUEregistrator: value.Eregistrator

            }
        }).subscribe(file => {
            let fileUrl = URL.createObjectURL(file);
            window.open(fileUrl);
        })
    }

    //#region private methods
    private addItem(item: T, list: List<T>): List<T> {
        if (!list)
            list = List([]);
        list = list.push(item);
        //item.Selected = true;
        //this.SelectMainItem(item);
        return list;
    }

    private updateItem(item: T, list: List<T>, index: number) {
        //list[index] = item;
        item.Selected = true;
        list = list.set(index, item);
        return list;
        //this.SelectMainItem(item);
    }

    private getItemIndex(id: number, list: List<T>) {
        let itemIndex: number = -1;
        list.forEach((item, index) => {
            if (item.ID == id)
                itemIndex = index;
        })
        return itemIndex;
    }

    private loadItems<T extends BaseEntity>(modelName: string, getName: string, parameters: QueryParameter[], modelClass: any, requestType: RequestType, getParameter: QueryParameter = null, postParameters: any = null) {
        if (requestType == RequestType.GET)
            return this.baseDataService.Get<T>(modelName, getName, parameters, modelClass);
        else if (requestType == RequestType.POST)
            return this.baseDataService.Post<T>(modelName, getName, postParameters, modelClass, getParameter);
        //.subscribe((data: T[]) => {
        //return data;
        //})

    }

    private processEmittedItem(item: T) {
        if (this._modelData)
            this.modelData = this._modelData;
        this.logTabFlowDebug('processEmittedItem', this.buildTabFlowSnapshot(item, item && item.ID != null ? item.ID : null));
        if (item == null) {
            this.mainItems.forEach(item => {
                if (item.Selected)
                    this.SelectMainItem(item);
            })
        }
        else if (this.modelData.RefreshType == RefreshType.NoReload) {
            let index = this.getItemIndex(item.ID, this.mainItems);
            let indexDetail1 = this.getItemIndex(item.ID, this.detail1Items);
            if (index == -1 && item[this.modelData.MainList.DefaultPropertyName] != null) {
                this.mainItems = this.addItem(item, this.mainItems);
                this.SelectMainItem(item);
            }
            // else if(index > -1 && item[this.modelData.MainList.DefaultPropertyName] != null){
            //   if (item[this.modelData.MainList.DefaultPropertyName] != null) {
            //     this.LoadMainItemsWithID(this.filterComponent ? this.filterComponent.filterFormGroup.value : null, item.ID)
            //       .subscribe((data: T[]) => {
            //         if (data) {

            //           this.mainItems = this.updateItem(item, this.mainItems, index);
            //         } 
            //       })
            //   }
            //         this.SelectMainItem(item);
            // }

            else if (index > -1 && item[this.modelData.MainList.DefaultPropertyName] != null) {
                this.LoadMainItemsWithID(
                    this.filterComponent ? this.filterComponent.filterFormGroup.value : null, item.ID)
                    .subscribe((data: T[]) => {
                        if (data && data.length) {
                            const freshItem = data.find(d => d.ID == item.ID);
                            this.mainItems = this.updateItem(freshItem, this.mainItems, index);
                            this.SelectMainItem(freshItem);
                        }
                    });
            }

            else if (index > -1 && item[this.modelData.MainList.DefaultPropertyName] == null) {
                this.mainItems = this.mainItems.splice(index, 1);
            }
            else if (indexDetail1 > -1) {
                this.detail1Items = this.updateItem(item, this.detail1Items, indexDetail1);

                const refresh = this.modelData.MainList.DetailList[1].RefreshMainlistItem;
                if (refresh) {
                    this.RefreshMainItem(this.parentID);
                }
            }
            else {
                this.detail1Items = this.addItem(item, this.detail1Items);

                const refresh = this.modelData.MainList.DetailList[1].RefreshMainlistItem;
                if (refresh) {
                    this.RefreshMainItem(this.parentID);
                }
            }

            //this.itemsUpdated = true;
            //this.mainItemsSubject.next(Object.assign([], this.mainItems));
            //this.SelectMainItem(item);
        }
        else {
            this.LoadMainItems(true, this.filterComponent ? this.filterComponent.filterFormGroup.value : null);

            if (this.parentID != null && this.parentID > 0) {
                this.LoadDetailItems(this.parentID);
            }
        }
    }

    private getPropertyValue(property) {
        //if(property instanceof String || property instanceof Number)
        if (typeof (property) == 'string' || typeof (property) == 'number')
            return property;
        else if (property instanceof Object && property.hasOwnProperty('day'))
            //return property['day'] + '.' + property['month'] + '.' + property['year'];
            return property['day'] + this.userService.GetDateSeparator() + property['month'] + this.userService.GetDateSeparator() + property['year'];
        else return 'Objekat';
    }

    selectNameMetod(item: T): Observable<T[]> {
        const filter = this.filterComponent.filterFormGroup.value;
        let id = null;
        this.mainItems.forEach(mainItem => {
            if (!item) {
                if (mainItem.Selected)
                    id = mainItem.ID
            }
        });

        if (id == null && !item) {
            return of([] as T[]);
        }

        const filterParameters = {
            id: id != null ? id : item.ID,
            odDatuma: filter.OdDatuma,
            doDatuma: filter.DoDatuma
        };

        return this.baseDataService.Post(this.modelData.MainList.ModelName, this.modelData.MainList.SelectName, filterParameters, this.modelData.MainList.ShortModelClass);
    }
    getTotalRecords(filterParameters: any = null) {
        let params = filterParameters;
        if (!params) {
            params = this.filterComponent.filterFormGroup.value;
        }

        this.baseDataService.Post(
            this.modelData.MainList.ModelName,
            "GetNumberByFilter",
            params,
            null
        ).subscribe((item: any) => {
            if (item != null) {
                this.totalRecords = item;
                this.totalRecordsChanged.emit(this.totalRecords);
            }
        });
    }

    public GetMainSelectionState(): { id: number, index: number } {
        if (!this.mainItems || this.mainItems.size === 0) {
            return { id: null, index: -1 };
        }

        const selectedItem: any = this.mainItems.find((item: any) => item && item.Selected === true);

        if (!selectedItem) {
            const firstItem: any = this.mainItems.get(0);
            return {
            id: firstItem ? firstItem.ID : null,
            index: firstItem ? 0 : -1
            };
        }

        return {
            id: selectedItem.ID,
            index: this.mainItems.findIndex((item: any) => item && item.ID === selectedItem.ID)
        };
    }

    public UpdateMainItemWithoutSelectionChange(updatedItem: T): void {
        if (!updatedItem || !this.mainItems) {
            return;
        }

        const selectedState = this.GetMainSelectionState();

        const index = this.mainItems.findIndex((item: any) => item && item.ID === updatedItem.ID);

        if (index < 0) {
            return;
        }

        const oldItem: any = this.mainItems.get(index);

        (updatedItem as any).Selected = oldItem ? oldItem.Selected === true : false;
        (updatedItem as any).Checked = oldItem ? oldItem.Checked === true : false;

        this.mainItems = this.mainItems.set(index, updatedItem);

        this.RestoreMainSelection(selectedState.id, selectedState.index, false);
    }

    public AddOrUpdateMainItemWithoutSelectionChange(item: T): void {
        if (!item || !this.mainItems) {
            return;
        }

        const selectedState = this.GetMainSelectionState();

        const index = this.mainItems.findIndex((x: any) => x && x.ID === (item as any).ID);

        if (index >= 0) {
            const oldItem: any = this.mainItems.get(index);

            (item as any).Selected = oldItem ? oldItem.Selected === true : false;
            (item as any).Checked = oldItem ? oldItem.Checked === true : false;

            this.mainItems = this.mainItems.set(index, item);
        } else {
            (item as any).Selected = false;
            (item as any).Checked = false;

            this.mainItems = this.mainItems.push(item);
        }

        this.RestoreMainSelection(selectedState.id, selectedState.index, false);
    }

    public RestoreMainSelection(selectedItemId: number, selectedItemIndex: number, loadDetails: boolean = true): void {
        if (!this.mainItems || this.mainItems.size === 0) {
            return;
        }

        let item: any = selectedItemId
            ? this.mainItems.find((x: any) => x && x.ID === selectedItemId)
            : null;

        if (!item && selectedItemIndex >= 0 && selectedItemIndex < this.mainItems.size) {
            item = this.mainItems.get(selectedItemIndex);
        }

        if (!item) {
            item = this.mainItems.get(0);
        }

        if (!item) {
            return;
        }

        this.mainItems.forEach((x: any) => {
            x.Selected = false;
        });

        item.Selected = true;

        if (loadDetails) {
            this.SelectMainItem(item);
        }

        if (this.defaultTable) {
            this.defaultTable.SetSelectedItem = item;
            this.defaultTable.ScrollToView = true;
        }
    }

    //#endregion
}
